<template>
    <div class="web-page" :class="{'web-page-bg':showBg}">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        props: {
            showBg: {
                type: Boolean,
                default: true
            }
        }
    }
</script>

<style lang="scss" scoped>
    .web-page-bg {
        background: url("../assets/top-bg.svg") no-repeat 0 0;
        background-size: contain;
    }
</style>
